
import axios from 'axios'

const svgEditor = {
  state: {
    // 选中工具栏
    currentlySelectedToolBar: {
      Type: '', // 选中的工具栏svg类型
      TypeName: '', // 选中的工具栏svg类型名称
      Title: '', // 选中的工具栏svg标题
      Color: '', // 选中的工具栏svg颜色
      CreateType: '', // 选中工具栏的创建方式
      EChartsOption: ''// 选中工具栏的图表默认option
    }
  },

  mutations: {
    setCurrentlySelectedToolBarAction(state, value) {
      state.currentlySelectedToolBar = value
    },
    clearCurrentlySelectedToolBarAction(state) {
      state.currentlySelectedToolBar = {
        Type: '', // 选中的工具栏svg类型
        TypeName: '', // 选中的工具栏svg类型名称
        Title: '', // 选中的工具栏svg标题
        Color: '', // 选中的工具栏svg颜色
        CreateType: '', // 选中工具栏的创建方式
        EChartsOption: ''// 选中工具栏的图表默认option
      }
    }
  },

  actions: {
    setCurrentlySelectedToolBarAction({ commit }, value) {
      commit('setCurrentlySelectedToolBarAction', value)
    },
    clearCurrentlySelectedToolBarAction({ commit }) {
      commit('clearCurrentlySelectedToolBarAction')
    },
    loadNoramlSvgIcons({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/svgEditor/InterfaceReturn.json').then((response) => {
          resolve(response.data)
        }).catch((error) => {
          console.log(error)
        })
      })
    },
    loadSvgExample({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/svgEditor/example.json').then((response) => {
          resolve(response.data)
        }).catch((error) => {
          console.log(error)
        })
      })
    }

  }
}

export default svgEditor
